<template>
  <div class="registerBox">
    <el-header height="46px">
      <!-- <span class="text" @click="loginTo">已有账号，立即登录</span> -->
    </el-header>
    <div class="body">
      <div class="body-text">
        <span v-if="businessFlg == '1'">业务类型：托运业务</span>
        <span v-if="businessFlg == '2'">业务类型：承运业务</span>
        <span v-if="businessFlg == '3'">业务类型：车队长业务</span>
      </div>

        <el-form
          :model="tuoYunFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          ref="tuoYunFrom"
          class="demo-form-inline"
          label-width="180px" size="small">
          <div class="fromBox">
          <el-form-item label="企业名称：" prop="businessName" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入企业名称" maxlength="" v-model.trim="tuoYunFrom.businessName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="营业执照号：" prop="businessLicenseNo" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入营业执照号" @blur="getUserNameOrTel" maxlength="" v-model.trim="tuoYunFrom.businessLicenseNo" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="道路运输经营许可证号：" prop="daoLuYunShu" v-if="businessFlg == '2'">
            <el-input  placeholder="道路运输经营许可证号" maxlength="" v-model.trim="tuoYunFrom.daoLuYunShu" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名：" prop="legalPersonName" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入法人姓名" maxlength="" v-model.trim="tuoYunFrom.legalPersonName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="车队长姓名：" prop="legalPersonName" v-if="businessFlg == '3'">
            <el-input  placeholder="请输入车队长姓名" maxlength="" v-model.trim="tuoYunFrom.legalPersonName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="身份证号：" prop="legalPersonId">
            <el-input  placeholder="请输入法人身份证号" maxlength="18" v-model.trim="tuoYunFrom.legalPersonId" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证有效期：" prop="termOfValidity" v-if="businessFlg != '3'">
            <el-input  placeholder="请输入法人身份证有效期（格式2020-08-27）" maxlength="" v-model.trim="tuoYunFrom.termOfValidity" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="userName">
            <el-input  placeholder="请输入联系人" maxlength="" :disabled="userNameDisabled" v-model.trim="tuoYunFrom.userName" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="userPhone">
            <el-input  placeholder="请输入联系电话" maxlength="11" :disabled="userNameDisabled" v-model.trim="tuoYunFrom.userPhone" style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="是否持有驾驶证" prop="bsnsOneness" v-if="businessFlg == '3'">
            <el-radio-group v-model="tuoYunFrom.bsnsOneness"   @change="radioChangeJSZ">
              <el-radio  label="0">是</el-radio>
              <el-radio  label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item label="驾驶证号" prop="transPermitno" v-if="businessFlg == '3'&&tuoYunFrom.bsnsOneness=='0'">
            <el-input  placeholder="请输入驾驶证号" maxlength="18" v-model.trim="tuoYunFrom.transPermitno " style="width:480px;"></el-input>
          </el-form-item>
          <el-form-item label="是否三证合一：" prop="tuoYunRadio" v-if="businessFlg != '3'">
            <el-radio-group v-model="tuoYunFrom.tuoYunRadio" @change="radioChange">
              <el-radio  label="0">是</el-radio>
              <el-radio  label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          </div>
          <!-- 三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.tuoYunRadio == '0' && businessFlg == '1'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewZ"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveZ" :class="[isAddImgZ?'hidden':'']">
                </el-upload>
                <span>营业执照</span>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg2"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg3"
                  :auto-upload=false
                  :on-change="imgPreview2"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove2" :class="[isAddImg2?'hidden':'']">
                </el-upload>
                <span>身份证反面</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 非三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.tuoYunRadio == '1' && businessFlg == '1'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox">
                <el-upload
                :file-list="listImg4"
                  action=""
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewF"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveF" :class="[isAddImgF?'hidden':'']">
                </el-upload>
                <span>营业执照</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg5"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewSW"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveSW" :class="[isAddImgSW?'hidden':'']">
                </el-upload>
                <span>税务登记证</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg6"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewDM"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveDM" :class="[isAddImgDM?'hidden':'']">
                </el-upload>
                <span>组织机构代码</span>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg7"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg8"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview2"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove2" :class="[isAddImg2?'hidden':'']">
                </el-upload>
                <span>身份证反面</span>
              </div>
              <div class="imgBox">
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 承运三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.tuoYunRadio == '0' && businessFlg == '2'">
          <el-form-item label="证件上传：">
            <div class="box">
              <div class="imgBox">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg9"
                  :auto-upload=false
                  :on-change="imgPreviewZ"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveZ" :class="[isAddImgZ?'hidden':'']">
                </el-upload>
                <span>营业执照</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg10"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewDL"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveDL" :class="[isAddImgDL?'hidden':'']">
                </el-upload>
                <span>道路运输经营许可证号</span>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg11"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg12"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview2"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove2" :class="[isAddImg2?'hidden':'']">
                </el-upload>
                <span>身份证反面</span>
              </div>
              <div class="imgBox">
              </div>
              <div class="imgBox">
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 承运非三证合一 -->
          <div class="uploadBox" v-if="tuoYunFrom.tuoYunRadio == '1' && businessFlg == '2'">
          <el-form-item label="证件上传：" >
            <div class="box">
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg13"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewF"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveF" :class="[isAddImgF?'hidden':'']">
                </el-upload>
                <span>营业执照</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg14"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewSW"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveSW" :class="[isAddImgSW?'hidden':'']">
                </el-upload>
                <span>税务登记证</span>
              </div>
              <div class="imgBox">
                <el-upload
                :file-list="listImg15"
                  action=""
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewDL"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveDL" :class="[isAddImgDL?'hidden':'']">
                </el-upload>
                <span>道路运输经营许可证号</span>
              </div>
              <div class="imgBox">
                <el-upload
                :file-list="listImg16"
                  action=""
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreviewDM"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveDM" :class="[isAddImgDM?'hidden':'']">
                </el-upload>
                <span>组织机构代码</span>
              </div>
               <div class="imgBox">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg17"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <span>身份证正面</span>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg18"
                  ref="upload"
                  :auto-upload=false
                  :on-change="imgPreview2"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove2" :class="[isAddImg2?'hidden':'']">
                </el-upload>
                <span>身份证反面</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <!-- 车队长证件 -->
          <div class="uploadBox" v-if="businessFlg == '3'">
          <el-form-item label="证件上传：" >
            <div class="box" style="width:650px;justify-content: initial;">
               <div class="imgBox" style="margin-right: 7px;">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg2"
                  :auto-upload=false
                  :on-change="imgPreview1"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                </el-upload>
                <span>身份证正面</span>
              </div>
              <div class="imgBox" style="margin-right: 7px;">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImg3"
                  :auto-upload=false
                  :on-change="imgPreview2"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemove2" :class="[isAddImg2?'hidden':'']">
                </el-upload>
                <span>身份证反面</span>
              </div>
               <div class="imgBox" style="margin-right: 7px;" v-if="tuoYunFrom.bsnsOneness=='0'">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImgJZ"
                  :auto-upload=false
                  :on-change="imgPreviewJZ"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveJZ" :class="[isAddImgJZ?'hidden':'']">
                </el-upload>
                <span>驾驶证正页</span>
              </div>
               <div class="imgBox" v-if="tuoYunFrom.bsnsOneness=='0'">
                <el-upload
                  action=""
                  ref="upload"
                  :file-list="listImgJF"
                  :auto-upload=false
                  :on-change="imgPreviewJF"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveJF" :class="[isAddImgJF?'hidden':'']">
                </el-upload>
                <span>驾驶证副页</span>
              </div>
            </div>
          </el-form-item>
          </div>
          <div class="submitBtn">
            <el-button type="primary" style="width:100%;height:40px;" size="amall" :loading="submitLoading" @click="submitClick('tuoYunFrom')">提交审核</el-button>
          </div>
        </el-form>
    </div>
  </div>
</template>
<script>
// import { encryption } from '@/utils/util'
// import InputGroup from '@/components/inputGroup.vue' // 引入封装的组件
// import store from '@/store's
export default {
  data () {
    return {
      businessFlg: '',
      // 托运
      tuoYunFrom: {
        businessName: '', // 企业名称
        businessLicenseNo: '', // 营业执照号
        legalPersonName: '', // 法人姓名
        legalPersonId: '', // 法人身份证
        termOfValidity: '', // 法人身份证有效期
        userName: '', // 联系人
        userPhone: '', // 联系电话
        tuoYunRadio: '0', // 托运三证合一
        daoLuYunShu: '', // 道路运输许可证号
        bsnsOneness: '0' // 是否有驾驶证
      },
      userNameDisabled: false,
      rules: {
        businessName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        businessLicenseNo: [
          { required: true, message: '请输入营业执照号', trigger: 'blur' }
        ],
        daoLuYunShu: [
          { required: true, message: '请输入道路运输经营许可证号', trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legalPersonId: [
          { required: true, message: '请输入法人身份证', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        termOfValidity: [
          { required: true, message: '请输入法人身份证有效期', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        userPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        tuoYunRadio: [
          { required: true, message: '请选择托运三证合一', trigger: 'blur' }
        ],
        upload: [
          { required: true, message: '请选择托运三证合一', trigger: 'blur' }
        ],
        transPermitno: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ]

      },
      listImg: [],
      listImg1: [],
      listImg2: [],
      listImg3: [],
      listImg4: [],
      listImg5: [],
      listImg6: [],
      listImg7: [],
      listImg8: [],
      listImg9: [],
      listImg10: [],
      listImg11: [],
      listImg12: [],
      listImg13: [],
      listImg14: [],
      listImg15: [],
      listImg16: [],
      listImg17: [],
      listImg18: [],
      isAddImgZ: false,
      isAddImg1: false,
      isAddImg2: false,
      isAddImgF: false,
      isAddImgDM: false,
      isAddImgSW: false,
      isAddImgDL: false,
      paramsZ: [],
      paramsF: [],
      params1: [],
      params2: [],
      paramsDM: [],
      paramsSW: [],
      paramsDL: [],
      listImgJZ: [],
      listImgJF: [],
      isAddImgJZ: false,
      isAddImgJF: false,
      submitLoading: false
    }
  },
  created () {
    this.businessFlg = localStorage.getItem('businessFlg')
  },
  methods: {
    // 已有账号，立即登录
    loginTo () {
      this.$router.push('/login')
    },
    // 验证手机
    validateMobile (mobile) {
      return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
    },
    // 营业执照失去焦点调接口获取联系人和联系电话
    getUserNameOrTel () {
      this.$axios({
        // headers: {
        //   'Content-Type': 'application/json;charset=UTF-8'
        //   // Authorization: 'Bearer ' + store.getUser().access_token
        // },
        method: 'post',
        url: this.global.crm + '/registerInfo/CheckCompanyName',
        data: {
          tenantName: this.tuoYunFrom.businessName, // 企业名称
          taxpayerNumber: this.tuoYunFrom.businessLicenseNo // 营业执照号
        }
      })
        .then(res => {
          // this.smsCode = res.data
          console.log(res, '555')
          if (res.data != null) {
            this.tuoYunFrom.userName = res.data.contactsName
            this.tuoYunFrom.userPhone = res.data.contactsMoblie
            this.userNameDisabled = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.userNameDisabled = false
          this.tuoYunFrom.userName = ''
          this.tuoYunFrom.userPhone = ''
          // this.$message.error(error.message)
        })
    },
    // 获取图片转base64
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    // 图片上传 托运三证合一营业执照
    handleRemoveZ (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgZ = false
      }
    },
    imgPreviewZ (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.paramsZ = res.split(',')
        if (this.paramsZ.length > 0) {
          this.strimagebase64 = this.paramsZ[1]
          this.isAddImgZ = true
        } else {
          this.isAddImgZ = false
        }
      })
      // console.log(this.listImg, '////')
      // let fileName = file.name
      // let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      // if (regex.test(fileName.toLowerCase())) {
      //   if (fileList.length < 1) {
      //     this.isAddImg = false
      //   } else {
      //     this.isAddImg = true
      //   }
      // } else {
      //   fileList.pop()
      //   this.$alert('请选择图片文件图', '系统提示')
      //   return false
      // }
      // this.listImg = fileList
    },
    // 托运非三证合一营业执照
    handleRemoveF (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgF = false
      }
    },
    imgPreviewF (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.paramsF = res.split(',')
        if (this.paramsF.length > 0) {
          this.strimagebase64 = this.paramsF[1]
          this.isAddImgF = true
        } else {
          this.isAddImgF = false
        }
      })
    },
    // 托运三证合一身份证正面
    // 图片上传
    handleRemove1 (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImg1 = false
        this.params1 = []
      }
    },
    imgPreview1 (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.params1 = res.split(',')
        if (this.params1.length > 0) {
          this.strimagebase64 = this.params1[1]
          this.isAddImg1 = true
        } else {
          this.isAddImg1 = false
        }
      })
    },
    // 图片上传
    // 托运三证合一身份证反面
    handleRemove2 (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImg2 = false
        this.params2 = []
      }
    },
    imgPreview2 (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.params2 = res.split(',')
        if (this.params2.length > 0) {
          this.strimagebase64 = this.params2[1]
          this.isAddImg2 = true
        } else {
          this.isAddImg2 = false
        }
      })
    },
    // 驾驶证
    handleRemoveJZ (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgJZ = false
        this.transPermitpic1 = null
      }
    },
    imgPreviewJZ (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.transPermitpic1 = res.split(',')
        if (this.transPermitpic1.length > 0) {
          this.isAddImgJZ = true
        } else {
          this.isAddImgJZ = false
        }
      })
    },
    handleRemoveJF (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgJF = false
        this.transPermitpic2 = null
      }
    },
    imgPreviewJF (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.transPermitpic2 = res.split(',')
        if (this.transPermitpic2.length > 0) {
          this.isAddImgJF = true
        } else {
          this.isAddImgJF = false
        }
      })
    },
    radioChangeJSZ () {
      if (this.tuoYunFrom.bsnsOneness == '1') {
        this.$set(this.tuoYunFrom, 'transPermitno', '')
        this.transPermitpic1 = null
        this.transPermitpic2 = null
        this.isAddImgJZ = false
        this.isAddImgJF = false
      }
    },
    // 组织机构代码
    handleRemoveDM (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgDM = false
      }
    },
    imgPreviewDM (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.paramsDM = res.split(',')
        console.log(this.paramsDM)
        if (this.paramsDM.length > 0) {
          this.strimagebase64 = this.paramsDM[1]
          this.isAddImgDM = true
        } else {
          this.isAddImgDM = false
        }
      })
    },
    // 税务登记证
    handleRemoveSW (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgSW = false
      }
    },
    imgPreviewSW (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.paramsSW = res.split(',')
        if (this.paramsSW.length > 0) {
          this.strimagebase64 = this.paramsSW[1]
          this.isAddImgSW = true
        } else {
          this.isAddImgSW = false
        }
      })
    },
    // 道路运输经营许可证
    handleRemoveDL (file, fileList) {
      if (fileList.length < 1) {
        this.isAddImgDL = false
      }
    },
    imgPreviewDL (file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.paramsDL = res.split(',')
        if (this.paramsDL.length > 0) {
          this.strimagebase64 = this.paramsDL[1]
          this.isAddImgDL = true
        } else {
          this.isAddImgDL = false
        }
      })
    },
    // 单选框的值改变时
    radioChange (val) {
      console.log(val)
      // 0是
      if (val == '1') {
        // this.$refs.upload.clearFiles()
        // this.listImg = []
        // 托运
        this.isAddImgF = false
        this.isAddImgSW = false
        this.isAddImgDM = false
        this.isAddImg1 = false
        this.isAddImg2 = false
        // 承运
        // this.isAddImgF = false
        this.isAddImgDL = false
      } else {
        // 托运
        this.isAddImgZ = false
        this.isAddImg1 = false
        this.isAddImg2 = false
        // 承运
        this.isAddImgDL = false
        this.isAddImgDM = false
      }
    },
    // 判断给定日期是否合法
    checkDate (dateStr) {
      dateStr = dateStr.replace(/\//g, '-')
      var dateReg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/
      var rValue = dateStr.match(dateReg)
      if (rValue == null) {
        return false
      }
      rValue[1] = parseInt(rValue[1], 10)
      rValue[2] = parseInt(rValue[2] - 1, 10)
      rValue[3] = parseInt(rValue[3], 10)
      var dateObj = new Date(rValue[1], rValue[2], rValue[3])
      if (dateObj.getFullYear() != rValue[1] || dateObj.getMonth() != rValue[2] || dateObj.getDate() != rValue[3]) {
        return false
      }
      return true
    },
    // 提交审核
    submitClick (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 日期
          if (this.businessFlg == '3') {
            if (this.params1[1] == undefined || this.params2[1] == undefined) {
              this.$message.error('请上传证件')
            } else if (this.params1[1] != undefined || this.params2[1] != undefined) {
              if (this.tuoYunFrom.bsnsOneness == 0 && (!this.transPermitpic1 || !this.transPermitpic2)) {
                this.$message.error('请上传驾驶证')
              } else {
                this.submitLoading = true
                this.$axios({
                  method: 'post',
                  url: this.global.crm + '/registerInfo/add',
                  data: {
                    userId: localStorage.getItem('registerId'),
                    businessFlg: this.businessFlg, // 业务类型
                    companyName: this.tuoYunFrom.businessName, // 企业名称
                    bsnsLicenseno: this.tuoYunFrom.businessLicenseNo, // 营业执照号
                    legalPerson: this.tuoYunFrom.legalPersonName, // 法人姓名
                    legalPersonId: this.tuoYunFrom.legalPersonId, // 法人身份证号
                    personidValidity: this.tuoYunFrom.termOfValidity, // 身份证有效期
                    legalPersonpic1: this.params1[1], // 法人身份证（正面）
                    legalPersonpic2: this.params2[1], // 法人身份证（背面）
                    bsnsLicensepic: this.paramsZ[1], // 营业执照（三证合一）
                    businessLicensepic: this.paramsF[1], // 营业执照（非三证合一）
                    taxOrgcodepic: this.paramsDM[1], // 组织机构代码（非三证合一）
                    taxRegistrapic: this.paramsSW[1], // 税务登记证（非三证合一）
                    transPermitno: this.tuoYunFrom.transPermitno, // 驾驶证号
                    transPermitpic1: this.transPermitpic1 ? this.transPermitpic1[1] : '', // 道路运输经营许可证照片
                    contractName: this.tuoYunFrom.userName, // 联系人
                    contractPhone: this.tuoYunFrom.userPhone, // 联系电话
                    bsnsOneness: this.tuoYunFrom.bsnsOneness, // 是否三证合一  0是1否
                    transPermitpic2: this.transPermitpic2 ? this.transPermitpic2[1] : ''
                  }
                })
                  .then(res => {
                    this.submitLoading = false
                    this.$message.success('提交审核成功，请等待审核结果！')
                    this.$router.push('/systemManagement/enterprise')
                  })
                  .catch(error => {
                    this.submitLoading = false
                    this.$message.error(error.message)
                  })
              }
            }
          } else {
            if (this.checkDate(this.tuoYunFrom.termOfValidity) == false) {
              this.$message.error('日期格式不正确')
            } else {
              this.submitLoading = true
              this.$axios({
                method: 'post',
                url: this.global.crm + '/registerInfo/add',
                data: {
                  userId: localStorage.getItem('registerId'),
                  businessFlg: this.businessFlg, // 业务类型
                  companyName: this.tuoYunFrom.businessName, // 企业名称
                  bsnsLicenseno: this.tuoYunFrom.businessLicenseNo, // 营业执照号
                  legalPerson: this.tuoYunFrom.legalPersonName, // 法人姓名
                  legalPersonId: this.tuoYunFrom.legalPersonId, // 法人身份证号
                  personidValidity: this.tuoYunFrom.termOfValidity, // 身份证有效期
                  legalPersonpic1: this.params1[1], // 法人身份证（正面）
                  legalPersonpic2: this.params2[1], // 法人身份证（背面）
                  bsnsLicensepic: this.paramsZ[1], // 营业执照（三证合一）
                  businessLicensepic: this.paramsF[1], // 营业执照（非三证合一）
                  taxOrgcodepic: this.paramsDM[1], // 组织机构代码（非三证合一）
                  taxRegistrapic: this.paramsSW[1], // 税务登记证（非三证合一）
                  transPermitno: this.tuoYunFrom.daoLuYunShu, // 道路运输经营许可证号
                  transPermitpic1: this.paramsDL[1], // 道路运输经营许可证照片
                  contractName: this.tuoYunFrom.userName, // 联系人
                  contractPhone: this.tuoYunFrom.userPhone, // 联系电话
                  bsnsOneness: this.tuoYunFrom.tuoYunRadio // 是否三证合一  0是1否
                }
              })
                .then(res => {
                  this.submitLoading = false
                  this.$message.success('提交审核成功，请等待审核结果！')
                  this.$router.push('/systemManagement/enterprise')
                })
                .catch(error => {
                  this.submitLoading = false
                  this.$message.error(error.message)
                })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/body{
  width: 100%;
  height: 100%;
  position: relative;
  // background-color:#fff ;
}
.registerBox{
  width: 100%;
  height: 100%;
  background-color:#fff ;
  position: relative;
  left: 0;
  top: 0;
  .el-header {
    background-color: #0c46a2;
    line-height: 46px;
    .text{
      float: right;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .body{
    width: 100%;
    height: 100%;
    position: relative;
    background-color:#fff ;
    // border: solid 1px;
    .body-text{
      font-size: 19px;
      text-align: center;
      padding: 30px 0 30px 0;
      // color: #409EFF;
    }
    .fromBox{
      width: 40%;
      margin: auto;
      // border: solid 1px;
    }
    .uploadBox{
      width: 41%;
      margin: auto;
    }
    .box{
      width: 500px;
      display: flex;
      justify-content: space-around;
      flex-wrap:wrap;
      .imgBox{
        display: flex;
        flex-direction: column;
        width: 150px;
        /deep/.el-upload--picture-card{
        // width: 180px;
        // height: 100px;
        }
        span{
          text-align: center;
        }
      }
      .hidden /deep/.el-upload--picture-card{
        display: none;
      }
      /deep/.el-upload--picture-card {
        background-image: url(../../../assets/images/upload2.png);
        // background-size:180px 100px;
      }
      /deep/.el-upload-list--picture-card .el-upload-list__item{
        // width: 150px;
        // height: 100px;
      }
    }
    .submitBtn{
      width: 480px;
      padding-top: 30px;
      padding-bottom: 3px;
      margin: auto;
    }
  }
}
</style>
